import RouteJourney from './route-journey/index'

export default function RouteForm() {
  return (
    <>
      <RouteJourney />
    </>
  )
}
